/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Type of action that is taking place
 */
export enum ActionType {
  ADD = "ADD",
  FAVORITE = "FAVORITE",
  PASS = "PASS",
  SHOWN = "SHOWN",
}

/**
 * Type of user that is taking the action
 */
export enum ActorType {
  PROVIDER = "PROVIDER",
  SEEKER = "SEEKER",
}

/**
 * Approximate care date
 */
export enum CareDate {
  JUST_BROWSING = "JUST_BROWSING",
  RIGHT_NOW = "RIGHT_NOW",
  WITHIN_A_MONTH = "WITHIN_A_MONTH",
  WITHIN_A_WEEK = "WITHIN_A_WEEK",
}

/**
 * Type of badges displayed on a Caregiver's profile
 */
export enum CaregiverBadge {
  BACKGROUND_CHECK = "BACKGROUND_CHECK",
  PREMIUM = "PREMIUM",
  VACCINATED = "VACCINATED",
}

/**
 * Member overall status
 */
export enum CaregiverOverallStatus {
  ACTIVE = "ACTIVE",
  ACTIVE_FEATURED = "ACTIVE_FEATURED",
  ACTIVE_GROUPIE = "ACTIVE_GROUPIE",
  ACTIVE_LITE = "ACTIVE_LITE",
  CLOSED = "CLOSED",
  INACTIVE = "INACTIVE",
  INCOMPLETE = "INCOMPLETE",
  NEW = "NEW",
  PENDING_CLOSE = "PENDING_CLOSE",
  STALE = "STALE",
  TRIAL_PREMIUM = "TRIAL_PREMIUM",
}

/**
 * Possible center types
 */
export enum CenterType {
  FCC = "FCC",
  INVALID = "INVALID",
  NATIONAL_ACCOUNT = "NATIONAL_ACCOUNT",
  SMALL_MEDIUM_BUSINESS = "SMALL_MEDIUM_BUSINESS",
}

/**
 * # Age groups child care caregiver can serve 
 */
export enum ChildCareAgeGroups {
  EARLY_SCHOOL = "EARLY_SCHOOL",
  ELEMENTARY_SCHOOL = "ELEMENTARY_SCHOOL",
  NEWBORN = "NEWBORN",
  TEEN = "TEEN",
  TODDLER = "TODDLER",
}

/**
 * Age range of the child care recipient.
 */
export enum ChildCareAgeRangeType {
  EARLY_SCHOOL = "EARLY_SCHOOL",
  ELEMENTARY_SCHOOL = "ELEMENTARY_SCHOOL",
  NEWBORN = "NEWBORN",
  TEEN = "TEEN",
  TODDLER = "TODDLER",
}

/**
 * The preferred contact method specified by the seeker
 */
export enum ChildCareLeadContactMethod {
  MAIL = "MAIL",
  PHONE = "PHONE",
}

/**
 * The way how Child Care Lead(s) were submitted
 */
export enum ChildCareLeadsSubmissionMethod {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}

/**
 * Child Caregiver's qualities
 */
export enum ChildCareProviderQuality {
  COLLEGE_DEGREE = "COLLEGE_DEGREE",
  COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS",
  CPR_TRAINED = "CPR_TRAINED",
  DOES_NOT_SMOKE = "DOES_NOT_SMOKE",
  OWN_TRANSPORTATION = "OWN_TRANSPORTATION",
}

/**
 * Care services that may be required as part of job
 */
export enum ChildCareService {
  DROP_PICKUP_CHILDREN = "DROP_PICKUP_CHILDREN",
  GROCERY_SHOPPING = "GROCERY_SHOPPING",
  HOMEWORK_HELP = "HOMEWORK_HELP",
  LAUNDRY = "LAUNDRY",
  LIGHT_HOUSEKEEPING = "LIGHT_HOUSEKEEPING",
  MEAL_PREPARATION = "MEAL_PREPARATION",
  REMOTE_LEARNING_ASSISTANCE = "REMOTE_LEARNING_ASSISTANCE",
  SPECIAL_NEEDS = "SPECIAL_NEEDS",
  STRUCTURED_ACTIVITIES = "STRUCTURED_ACTIVITIES",
}

/**
 * Child Care Day Care - Time of Day
 */
export enum DayCareTimeOfDay {
  AFTERNOON = "AFTERNOON",
  ALLDAY = "ALLDAY",
  MORNING = "MORNING",
}

/**
 * Measures of distance
 */
export enum DistanceUnit {
  KILOMETERS = "KILOMETERS",
  MILES = "MILES",
}

/**
 * Education level of provider
 */
export enum EducationLevel {
  COLLEGE = "COLLEGE",
  COLLEGE_DEGREE = "COLLEGE_DEGREE",
  GED = "GED",
  GRADUATE = "GRADUATE",
  GRADUATE_DEGREE = "GRADUATE_DEGREE",
  HIGH_SCHOOL = "HIGH_SCHOOL",
  HIGH_SCHOOL_DEGREE = "HIGH_SCHOOL_DEGREE",
  HIGH_SCHOOL_DIPLOMA = "HIGH_SCHOOL_DIPLOMA",
  SOME_COLLEGE = "SOME_COLLEGE",
  SOME_GRADUATE_SCHOOL = "SOME_GRADUATE_SCHOOL",
  SOME_HIGH_SCHOOL = "SOME_HIGH_SCHOOL",
}

/**
 * Approximate care date
 */
export enum EnrollmentSource {
  INSTANT_BOOK = "INSTANT_BOOK",
}

/**
 * The gender of an individual
 */
export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

/**
 * Answer to "How did you hear about Care.com?"
 */
export enum HOW_DID_YOU_HEAR_ABOUT_US {
  AUDIO = "AUDIO",
  BANNER_AD = "BANNER_AD",
  BILLBOARD = "BILLBOARD",
  CABLE_TELEVISION = "CABLE_TELEVISION",
  COMMERCIAL_NO = "COMMERCIAL_NO",
  COMMERCIAL_YES = "COMMERCIAL_YES",
  EMAILS_FROM_CARE = "EMAILS_FROM_CARE",
  FACEBOOK = "FACEBOOK",
  FRIENDS_OR_FAMILY = "FRIENDS_OR_FAMILY",
  INFLUENCER = "INFLUENCER",
  ONLINE_VIDEO = "ONLINE_VIDEO",
  OTHER = "OTHER",
  OTHER_SOCIAL_MEDIA = "OTHER_SOCIAL_MEDIA",
  PARENTING_GROUP = "PARENTING_GROUP",
  PRESS_COVERAGE = "PRESS_COVERAGE",
  RADIO_AUDIO_AD = "RADIO_AUDIO_AD",
  SEARCH_ENGINE = "SEARCH_ENGINE",
  SEARCH_ENGINE_EXPANDED = "SEARCH_ENGINE_EXPANDED",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  STREAMING_SERVICE = "STREAMING_SERVICE",
  TV_AD = "TV_AD",
  YOUTUBE = "YOUTUBE",
}

/**
 * Timeframes expected
 */
export enum HomePayExpectedHireTimeFrame {
  AS_SOON_AS_POSSIBLE = "AS_SOON_AS_POSSIBLE",
  TWO_PLUS_MONTHS = "TWO_PLUS_MONTHS",
  WITHIN_A_MONTH = "WITHIN_A_MONTH",
}

/**
 * Types of Caregiver
 */
export enum HomepayCaregiverType {
  CHILD_CARE = "CHILD_CARE",
  HOUSEKEEPING = "HOUSEKEEPING",
  OTHER = "OTHER",
  SENIOR_CARE = "SENIOR_CARE",
}

/**
 * Housekeeping services
 */
export enum HousekeepingService {
  ATTIC_CLEANING = "ATTIC_CLEANING",
  BASEMENT_CLEANING = "BASEMENT_CLEANING",
  BATHROOM_CLEANING = "BATHROOM_CLEANING",
  CABINET_CLEANING = "CABINET_CLEANING",
  CARPET_CLEANING = "CARPET_CLEANING",
  CHANGING_BED_LINENS = "CHANGING_BED_LINENS",
  DISHES = "DISHES",
  DUSTING = "DUSTING",
  FURNITURE_TREATMENT = "FURNITURE_TREATMENT",
  GENERAL_ROOM_CLEANING = "GENERAL_ROOM_CLEANING",
  HOUSE_SITTING = "HOUSE_SITTING",
  KITCHEN_CLEANING = "KITCHEN_CLEANING",
  LAUNDRY = "LAUNDRY",
  MOVE_OUT_CLEANING = "MOVE_OUT_CLEANING",
  ORGANIZATION = "ORGANIZATION",
  OVEN_CLEANING = "OVEN_CLEANING",
  PACKING_AND_UNPACKING = "PACKING_AND_UNPACKING",
  PET_WASTE_CLEANUP = "PET_WASTE_CLEANUP",
  PLANT_CARE = "PLANT_CARE",
  REFRIGERATOR_CLEANING = "REFRIGERATOR_CLEANING",
  SURFACE_POLISHING = "SURFACE_POLISHING",
  VACUUMING_MOPPING = "VACUUMING_MOPPING",
  WALL_WASHING = "WALL_WASHING",
  WINDOW_WASHING = "WINDOW_WASHING",
}

/**
 * How soon is care needed for this care recipient?
 */
export enum HowSoonIsCareNeeded {
  AS_SOON_AS_POSSIBLE = "AS_SOON_AS_POSSIBLE",
  PLANNING_FOR_FUTURE = "PLANNING_FOR_FUTURE",
  WITHIN_SIX_MONTHS = "WITHIN_SIX_MONTHS",
}

/**
 * What type of Id client is passing
 */
export enum IdType {
  MEMBER_ID = "MEMBER_ID",
  UUID = "UUID",
}

/**
 * Measures of job hours
 */
export enum JobHoursUnit {
  PER_JOB = "PER_JOB",
  PER_WEEK = "PER_WEEK",
}

/**
 * Source of provider job interests update
 */
export enum JobInterestUpdateSource {
  ENROLLMENT = "ENROLLMENT",
  NTH_DAY = "NTH_DAY",
}

/**
 * Languages currently supported by the native app
 */
export enum Language {
  AFRIKAANS = "AFRIKAANS",
  ALBANIAN = "ALBANIAN",
  ARABIC = "ARABIC",
  ARMENIAN = "ARMENIAN",
  AZERBAIJANI = "AZERBAIJANI",
  BELARUSIAN = "BELARUSIAN",
  BENGALI = "BENGALI",
  BOSNIAN = "BOSNIAN",
  BULGARIAN = "BULGARIAN",
  CAMBODIAN = "CAMBODIAN",
  CATALAN = "CATALAN",
  CHINESE = "CHINESE",
  CROATIAN = "CROATIAN",
  CZECH = "CZECH",
  DANISH = "DANISH",
  DUTCH = "DUTCH",
  ENGLISH = "ENGLISH",
  ESTONIAN = "ESTONIAN",
  FINNISH = "FINNISH",
  FRENCH = "FRENCH",
  GEORGIAN = "GEORGIAN",
  GERMAN = "GERMAN",
  GREEK = "GREEK",
  HEBREW = "HEBREW",
  HINDI = "HINDI",
  HUNGARIAN = "HUNGARIAN",
  ICELANDIC = "ICELANDIC",
  INDONESIAN = "INDONESIAN",
  ITALIAN = "ITALIAN",
  JAPANESE = "JAPANESE",
  KAZAKH = "KAZAKH",
  KOREAN = "KOREAN",
  KURDISH = "KURDISH",
  LAOTIAN = "LAOTIAN",
  LATVIAN = "LATVIAN",
  LITHUANIAN = "LITHUANIAN",
  MADARIN = "MADARIN",
  MALAY = "MALAY",
  MANDARIN = "MANDARIN",
  MOLDAVIAN = "MOLDAVIAN",
  MONGOLIAN = "MONGOLIAN",
  NEPALI = "NEPALI",
  NORWEGIAN = "NORWEGIAN",
  PERSIAN = "PERSIAN",
  POLISH = "POLISH",
  PORTUGUESE = "PORTUGUESE",
  PORTUGUESE_BRAZIL = "PORTUGUESE_BRAZIL",
  PUNJABI = "PUNJABI",
  ROMANIAN = "ROMANIAN",
  RUSSIAN = "RUSSIAN",
  SERBIAN = "SERBIAN",
  SERBO_CROATIAN = "SERBO_CROATIAN",
  SESOTHO = "SESOTHO",
  SIGN_ASL = "SIGN_ASL",
  SIGN_LANGUAGE_ASL = "SIGN_LANGUAGE_ASL",
  SIGN_LANGUAGE_SEE = "SIGN_LANGUAGE_SEE",
  SIGN_SEE = "SIGN_SEE",
  SINDHI = "SINDHI",
  SLOVAK = "SLOVAK",
  SLOVENIAN = "SLOVENIAN",
  SOMALI = "SOMALI",
  SPANISH = "SPANISH",
  SUDANESE = "SUDANESE",
  SWAHILI = "SWAHILI",
  SWEDISH = "SWEDISH",
  TAGALOG = "TAGALOG",
  TAJIK = "TAJIK",
  TAMIL = "TAMIL",
  TELUGU = "TELUGU",
  THAI = "THAI",
  TONGA = "TONGA",
  TURKISH = "TURKISH",
  UKRAINIAN = "UKRAINIAN",
  UKRANIAN = "UKRANIAN",
  URDU = "URDU",
  UZBEK = "UZBEK",
  VIETNAMESE = "VIETNAMESE",
  YIDDISH = "YIDDISH",
  ZULU = "ZULU",
}

/**
 * License status of a provider.
 */
export enum LicenseStatus {
  CERTIFIED = "CERTIFIED",
  COMING_SOON = "COMING_SOON",
  INVALID = "INVALID",
  LICENSED = "LICENSED",
  LICENSED_FOR_FCC = "LICENSED_FOR_FCC",
  LICENSED_NEGATIVE = "LICENSED_NEGATIVE",
  LICENSED_TRANSITIONALS = "LICENSED_TRANSITIONALS",
  NOT_LICENSED_NEGATIVE = "NOT_LICENSED_NEGATIVE",
  NOT_LICENSED_TRANSITIONAL = "NOT_LICENSED_TRANSITIONAL",
  UNKNOWN = "UNKNOWN",
  UNVERIFIED = "UNVERIFIED",
}

/**
 * Authentication roles assigned to a logged in user
 */
export enum LoggedInUserRole {
  CSR = "CSR",
  EMPLOYER = "EMPLOYER",
  LITE = "LITE",
  SEEKER = "SEEKER",
  SITTER = "SITTER",
  SMB_MEMBER = "SMB_MEMBER",
}

/**
 * Types for multiple vertical 
 */
export enum MultipleVerticalsTypes {
  CHILDCARE = "CHILDCARE",
  HOUSEKEEP = "HOUSEKEEP",
  PETCAREXX = "PETCAREXX",
  SENIRCARE = "SENIRCARE",
  TUTORINGX = "TUTORINGX",
}

/**
 * Seeker Newcare Experience
 */
export enum NewcareExperience {
  ENROLLMENT = "ENROLLMENT",
}

/**
 * Animal Types for Pet Care
 */
export enum PetCareAnimalType {
  AMPHIBIAN = "AMPHIBIAN",
  BIRD = "BIRD",
  CAT = "CAT",
  DOG = "DOG",
  EXOTIC = "EXOTIC",
  FARM_ANIMAL = "FARM_ANIMAL",
  FISH = "FISH",
  HORSE = "HORSE",
  MAMMAL = "MAMMAL",
  OTHER = "OTHER",
}

/**
 * Types of petcare certifications.
 */
export enum PetCareCertificationType {
  BONDED_AND_INSURED = "BONDED_AND_INSURED",
  NAPPS_CERTIFIED = "NAPPS_CERTIFIED",
  PSA_MEMBER_AND_INSURED = "PSA_MEMBER_AND_INSURED",
  RED_CROSS_FIRST_AID_COURSE = "RED_CROSS_FIRST_AID_COURSE",
}

/**
 * Care subtypes that may be provided within Pet Care vertical
 */
export enum PetCareSubtype {
  ADMINISTRATION_OF_MEDICINE = "ADMINISTRATION_OF_MEDICINE",
  BOARDING = "BOARDING",
  BOARDING_KENNELING = "BOARDING_KENNELING",
  DAILY_FEEDING = "DAILY_FEEDING",
  DAYCARE = "DAYCARE",
  DOG_TRAINING = "DOG_TRAINING",
  GROOMING = "GROOMING",
  SITTING = "SITTING",
  TRANSPORTATION = "TRANSPORTATION",
  WALKING = "WALKING",
  WALKING_30_MINUTES = "WALKING_30_MINUTES",
  WALKING_60_MINUTES = "WALKING_60_MINUTES",
}

/**
 * Provider Pet Care Service Type
 */
export enum ProviderPetCareServiceType {
  BOARDING = "BOARDING",
  DAYCARE = "DAYCARE",
  SITTING = "SITTING",
  WALKING = "WALKING",
}

/**
 * Seeker care type
 */
export enum SENIOR_CARE_TYPE {
  IN_FACILITY = "IN_FACILITY",
  IN_HOME = "IN_HOME",
  NOT_SURE = "NOT_SURE",
}

/**
 * Possible reasons for a provider to be returned from an expanded search
 */
export enum SearchMatchReason {
  EXPANDED_RADIUS_MATCH = "EXPANDED_RADIUS_MATCH",
  OTHER_MATCH = "OTHER_MATCH",
  POSTAL_CODE_MATCH = "POSTAL_CODE_MATCH",
  UNKNOWN_MATCH = "UNKNOWN_MATCH",
  USER_RADIUS_MATCH = "USER_RADIUS_MATCH",
}

/**
 * Age range of the senior care recipient.
 */
export enum SeniorCareAgeRangeType {
  EIGHTIES = "EIGHTIES",
  FIFTIES = "FIFTIES",
  FORTIES = "FORTIES",
  HUNDREDS = "HUNDREDS",
  NINETIES = "NINETIES",
  SEVENTIES = "SEVENTIES",
  SIXTIES = "SIXTIES",
  THIRTIES = "THIRTIES",
}

/**
 * Specific amenities that are offered by the senior care facility
 */
export enum SeniorCareFacilityAmenity {
  ART_CLASSES = "ART_CLASSES",
  BEAUTY_SALON = "BEAUTY_SALON",
  COMMUNITY_DINING = "COMMUNITY_DINING",
  EXERCISE_GROUPS = "EXERCISE_GROUPS",
  LIBRARY = "LIBRARY",
  PET_FRIENDLY = "PET_FRIENDLY",
}

/**
 * The available sources of payment for care.
 */
export enum SeniorCarePaymentSource {
  GOVERNMENT_HEALTH_PROGRAM = "GOVERNMENT_HEALTH_PROGRAM",
  HOME_EQUITY = "HOME_EQUITY",
  LONG_TERM_CARE_INSURANCE = "LONG_TERM_CARE_INSURANCE",
  OTHER = "OTHER",
  PRIVATE_PAY = "PRIVATE_PAY",
  VETERANS_BENEFITS = "VETERANS_BENEFITS",
}

/**
 * Types of provider qualities and qualifications.
 */
export enum SeniorCareProviderQuality {
  ALZHEIMERS_OR_DEMENTIA_EXPERIENCE = "ALZHEIMERS_OR_DEMENTIA_EXPERIENCE",
  CERTIFIED_NURSING_ASSISTANT = "CERTIFIED_NURSING_ASSISTANT",
  COMFORTABLE_WITH_PETS = "COMFORTABLE_WITH_PETS",
  CPR_TRAINED = "CPR_TRAINED",
  DOES_NOT_SMOKE = "DOES_NOT_SMOKE",
  HOME_HEALTH_AIDE_EXPERIENCE = "HOME_HEALTH_AIDE_EXPERIENCE",
  HOSPICE_EXPERIENCE = "HOSPICE_EXPERIENCE",
  LICENSED_NURSE = "LICENSED_NURSE",
  MEDICAL_EQUIPMENT_EXPERIENCE = "MEDICAL_EQUIPMENT_EXPERIENCE",
  OWN_TRANSPORTATION = "OWN_TRANSPORTATION",
  REGISTERED_NURSE = "REGISTERED_NURSE",
  WOUND_CARE = "WOUND_CARE",
}

/**
 * The condition of the care recipient.
 */
export enum SeniorCareRecipientCondition {
  CONSTANT_SUPERVISION_NEEDED = "CONSTANT_SUPERVISION_NEEDED",
  INDEPENDENT = "INDEPENDENT",
  MONITORING_OR_EXTRA_HELP_NEEDED = "MONITORING_OR_EXTRA_HELP_NEEDED",
  NOT_SURE = "NOT_SURE",
}

/**
 * The care recipient's relationship to the seeker.
 */
export enum SeniorCareRecipientRelationshipType {
  GRANDPARENT = "GRANDPARENT",
  OTHER = "OTHER",
  PARENT = "PARENT",
  SELF = "SELF",
  SPOUSE = "SPOUSE",
}

/**
 * Specific services needed by the senior care recipient.
 */
export enum SeniorCareServiceNeededType {
  BATHING = "BATHING",
  COMPANIONSHIP = "COMPANIONSHIP",
  ERRANDS = "ERRANDS",
  FEEDING = "FEEDING",
  HEAVY_LIFTING = "HEAVY_LIFTING",
  HELP_STAYING_PHYSICALLY_ACTIVE = "HELP_STAYING_PHYSICALLY_ACTIVE",
  LIGHT_HOUSECLEANING = "LIGHT_HOUSECLEANING",
  MEAL_PREPARATION = "MEAL_PREPARATION",
  MEDICATION = "MEDICATION",
  MOBILITY_ASSISTANCE = "MOBILITY_ASSISTANCE",
  TRANSPORTATION = "TRANSPORTATION",
  WOUND_CARE = "WOUND_CARE",
}

/**
 * Specific services needed by the senior care recipient.
 * This enum set is *mostly* analogous to what we have in job/seniorSchema.graphql, however some values do not match up,
 * which is the reason for maintaining a separate set of enums.
 */
export enum SeniorCareServiceProvidedType {
  BATHING = "BATHING",
  COMPANIONSHIP = "COMPANIONSHIP",
  DEMENTIA = "DEMENTIA",
  ERRANDS = "ERRANDS",
  FEEDING = "FEEDING",
  HEAVY_LIFTING = "HEAVY_LIFTING",
  HELP_STAYING_PHYSICALLY_ACTIVE = "HELP_STAYING_PHYSICALLY_ACTIVE",
  HOME_HEALTH = "HOME_HEALTH",
  HOME_MODIFICATION = "HOME_MODIFICATION",
  HOSPICE_SERVICES = "HOSPICE_SERVICES",
  LIGHT_HOUSECLEANING = "LIGHT_HOUSECLEANING",
  LIVE_IN_HOME_CARE = "LIVE_IN_HOME_CARE",
  MEAL_PREPARATION = "MEAL_PREPARATION",
  MEDICAL_MANAGEMENT = "MEDICAL_MANAGEMENT",
  MEDICAL_TRANSPORTATION = "MEDICAL_TRANSPORTATION",
  MOBILITY_ASSISTANCE = "MOBILITY_ASSISTANCE",
  PERSONAL_CARE = "PERSONAL_CARE",
  RESPITE_CARE = "RESPITE_CARE",
  SPECIALIZED_CARE = "SPECIALIZED_CARE",
  SPECIAL_NEEDS = "SPECIAL_NEEDS",
  TRANSPORTATION = "TRANSPORTATION",
  VISITING_NURSE = "VISITING_NURSE",
  VISITING_PHYSICIAN = "VISITING_PHYSICIAN",
}

/**
 * The type of senior care community
 */
export enum SeniorCommunityType {
  ASSISTED_LIVING = "ASSISTED_LIVING",
  CONTINUING_CARE = "CONTINUING_CARE",
  INDEPENDENT_LIVING = "INDEPENDENT_LIVING",
  MEMORY_CARE = "MEMORY_CARE",
}

/**
 * type of service provided by the caregiver
 * will be adding more services as required
 */
export enum ServiceType {
  AU_PAIR = "AU_PAIR",
  CARE_GIGS = "CARE_GIGS",
  CHILD_CARE = "CHILD_CARE",
  GENERIC = "GENERIC",
  HOUSEKEEPING = "HOUSEKEEPING",
  PET_CARE = "PET_CARE",
  SENIOR_CARE = "SENIOR_CARE",
  SPECIAL_NEEDS = "SPECIAL_NEEDS",
  TUTORING = "TUTORING",
}

/**
 * Type of sub service for service provided
 * 
 * @deprecated in favor of vertical-specific enums i.e. ChildcareSubtype, PetCareSubtype, etc
 */
export enum SubServiceType {
  BABYSITTER = "BABYSITTER",
  CHILDMINDER = "CHILDMINDER",
  DAY_CARE = "DAY_CARE",
  FAMILY_CARE = "FAMILY_CARE",
  NANNY = "NANNY",
  NANNY_OR_BABYSITTER = "NANNY_OR_BABYSITTER",
  NANNY_SHARE = "NANNY_SHARE",
  ONE_TIME_BABYSITTER = "ONE_TIME_BABYSITTER",
}

/**
 * The type of analysis that is performed on the given string
 */
export enum TextConcernType {
  PII = "PII",
  PROFANITY = "PROFANITY",
  UNKNOWN = "UNKNOWN",
}

/**
 * Different states for provider tour requests opt-in/out.
 */
export enum TourRequestStatus {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  INVALID = "INVALID",
}

/**
 * Types of tutoring qualities and qualifications.
 */
export enum TutoringCertification {
  AMERICAN_TUTORING_ASSOCIATION_CERTIFIED = "AMERICAN_TUTORING_ASSOCIATION_CERTIFIED",
  CERTIFIED_TEACHER = "CERTIFIED_TEACHER",
}

/**
 * Tutoring education level
 */
export enum TutoringEducationLevel {
  ADULT = "ADULT",
  COLLEGE = "COLLEGE",
  ELEMENTARY = "ELEMENTARY",
  HIGH_SCHOOL = "HIGH_SCHOOL",
  MIDDLE_SCHOOL = "MIDDLE_SCHOOL",
}

/**
 * Types of tutoring experience.
 */
export enum TutoringExperience {
  TUTORS_IN_CENTER = "TUTORS_IN_CENTER",
  TUTORS_IN_STUDENTS_HOME = "TUTORS_IN_STUDENTS_HOME",
  TUTORS_IN_TEACHERS_HOME = "TUTORS_IN_TEACHERS_HOME",
  TUTORS_ONLINE = "TUTORS_ONLINE",
}

/**
 * Specific Subject Types for Tutoring
 */
export enum TutoringSpecificSubjectType {
  ART_SUBJECT_ART_HISTORY = "ART_SUBJECT_ART_HISTORY",
  ART_SUBJECT_DRAWING = "ART_SUBJECT_DRAWING",
  ART_SUBJECT_PAINTING = "ART_SUBJECT_PAINTING",
  ART_SUBJECT_PHOTOGRAPHY = "ART_SUBJECT_PHOTOGRAPHY",
  BUSINESS_SUBJECT_ACCOUNTING = "BUSINESS_SUBJECT_ACCOUNTING",
  BUSINESS_SUBJECT_ECONOMICS = "BUSINESS_SUBJECT_ECONOMICS",
  BUSINESS_SUBJECT_FINANCE = "BUSINESS_SUBJECT_FINANCE",
  BUSINESS_SUBJECT_MARKETING = "BUSINESS_SUBJECT_MARKETING",
  BUSINESS_SUBJECT_ORGANIZATIONAL_BEHAVIOR = "BUSINESS_SUBJECT_ORGANIZATIONAL_BEHAVIOR",
  COMPUTERS_SUBJECT_ANDROID_APP_DEVELOPMENT = "COMPUTERS_SUBJECT_ANDROID_APP_DEVELOPMENT",
  COMPUTERS_SUBJECT_BASIC = "COMPUTERS_SUBJECT_BASIC",
  COMPUTERS_SUBJECT_C = "COMPUTERS_SUBJECT_C",
  COMPUTERS_SUBJECT_COMPUTER_BASICS = "COMPUTERS_SUBJECT_COMPUTER_BASICS",
  COMPUTERS_SUBJECT_COMPUTER_SCIENCE = "COMPUTERS_SUBJECT_COMPUTER_SCIENCE",
  COMPUTERS_SUBJECT_CPP = "COMPUTERS_SUBJECT_CPP",
  COMPUTERS_SUBJECT_HTML = "COMPUTERS_SUBJECT_HTML",
  COMPUTERS_SUBJECT_INTERNET_SITE_DESIGN = "COMPUTERS_SUBJECT_INTERNET_SITE_DESIGN",
  COMPUTERS_SUBJECT_IOS_APP_DEVELOPMENT = "COMPUTERS_SUBJECT_IOS_APP_DEVELOPMENT",
  COMPUTERS_SUBJECT_JAVA = "COMPUTERS_SUBJECT_JAVA",
  COMPUTERS_SUBJECT_JAVASCRIPT = "COMPUTERS_SUBJECT_JAVASCRIPT",
  COMPUTERS_SUBJECT_LINUX = "COMPUTERS_SUBJECT_LINUX",
  COMPUTERS_SUBJECT_MACINTOSH = "COMPUTERS_SUBJECT_MACINTOSH",
  COMPUTERS_SUBJECT_MICROSOFT_ACCESS = "COMPUTERS_SUBJECT_MICROSOFT_ACCESS",
  COMPUTERS_SUBJECT_MICROSOFT_EXCEL = "COMPUTERS_SUBJECT_MICROSOFT_EXCEL",
  COMPUTERS_SUBJECT_MICROSOFT_OFFICE = "COMPUTERS_SUBJECT_MICROSOFT_OFFICE",
  COMPUTERS_SUBJECT_MICROSOFT_POWERPOINT = "COMPUTERS_SUBJECT_MICROSOFT_POWERPOINT",
  COMPUTERS_SUBJECT_MICROSOFT_WINDOWS = "COMPUTERS_SUBJECT_MICROSOFT_WINDOWS",
  COMPUTERS_SUBJECT_MICROSOFT_WORD = "COMPUTERS_SUBJECT_MICROSOFT_WORD",
  COMPUTERS_SUBJECT_OUTLOOK = "COMPUTERS_SUBJECT_OUTLOOK",
  COMPUTERS_SUBJECT_PHOTOSHOP = "COMPUTERS_SUBJECT_PHOTOSHOP",
  COMPUTERS_SUBJECT_PROGRAMMING = "COMPUTERS_SUBJECT_PROGRAMMING",
  COMPUTERS_SUBJECT_PYTHON = "COMPUTERS_SUBJECT_PYTHON",
  COMPUTERS_SUBJECT_VISUAL_BASIC = "COMPUTERS_SUBJECT_VISUAL_BASIC",
  COMPUTERS_SUBJECT_WINDOWS = "COMPUTERS_SUBJECT_WINDOWS",
  DANCE_SUBJECT_BALLET = "DANCE_SUBJECT_BALLET",
  DANCE_SUBJECT_HIP_HOP = "DANCE_SUBJECT_HIP_HOP",
  DANCE_SUBJECT_JAZZ = "DANCE_SUBJECT_JAZZ",
  ENGLISH_SUBJECT_ESL = "ENGLISH_SUBJECT_ESL",
  ENGLISH_SUBJECT_GRAMMAR = "ENGLISH_SUBJECT_GRAMMAR",
  ENGLISH_SUBJECT_LANGUAGE_ARTS_K6 = "ENGLISH_SUBJECT_LANGUAGE_ARTS_K6",
  ENGLISH_SUBJECT_LITERATURE = "ENGLISH_SUBJECT_LITERATURE",
  ENGLISH_SUBJECT_READING = "ENGLISH_SUBJECT_READING",
  ENGLISH_SUBJECT_WRITING = "ENGLISH_SUBJECT_WRITING",
  FOREIGN_LANGUAGE_SUBJECT_ARABIC = "FOREIGN_LANGUAGE_SUBJECT_ARABIC",
  FOREIGN_LANGUAGE_SUBJECT_CHINESE = "FOREIGN_LANGUAGE_SUBJECT_CHINESE",
  FOREIGN_LANGUAGE_SUBJECT_FRENCH = "FOREIGN_LANGUAGE_SUBJECT_FRENCH",
  FOREIGN_LANGUAGE_SUBJECT_GERMAN = "FOREIGN_LANGUAGE_SUBJECT_GERMAN",
  FOREIGN_LANGUAGE_SUBJECT_HINDI = "FOREIGN_LANGUAGE_SUBJECT_HINDI",
  FOREIGN_LANGUAGE_SUBJECT_ITALIAN = "FOREIGN_LANGUAGE_SUBJECT_ITALIAN",
  FOREIGN_LANGUAGE_SUBJECT_JAPANESE = "FOREIGN_LANGUAGE_SUBJECT_JAPANESE",
  FOREIGN_LANGUAGE_SUBJECT_LATIN = "FOREIGN_LANGUAGE_SUBJECT_LATIN",
  FOREIGN_LANGUAGE_SUBJECT_PORTUGUESE = "FOREIGN_LANGUAGE_SUBJECT_PORTUGUESE",
  FOREIGN_LANGUAGE_SUBJECT_RUSSIAN = "FOREIGN_LANGUAGE_SUBJECT_RUSSIAN",
  FOREIGN_LANGUAGE_SUBJECT_SPANISH = "FOREIGN_LANGUAGE_SUBJECT_SPANISH",
  MATH_SUBJECT_ALGEBRA = "MATH_SUBJECT_ALGEBRA",
  MATH_SUBJECT_CALCULUS = "MATH_SUBJECT_CALCULUS",
  MATH_SUBJECT_ELEMENTARY_SCHOOL_MATH = "MATH_SUBJECT_ELEMENTARY_SCHOOL_MATH",
  MATH_SUBJECT_GEOMETRY = "MATH_SUBJECT_GEOMETRY",
  MATH_SUBJECT_HIGH_SCHOOL_MATH = "MATH_SUBJECT_HIGH_SCHOOL_MATH",
  MATH_SUBJECT_MIDDLE_SCHOOL_MATH = "MATH_SUBJECT_MIDDLE_SCHOOL_MATH",
  MATH_SUBJECT_PRE_CALCULUS = "MATH_SUBJECT_PRE_CALCULUS",
  MUSICAL_INSTRUMENTS_SUBJECT_CLARINET = "MUSICAL_INSTRUMENTS_SUBJECT_CLARINET",
  MUSICAL_INSTRUMENTS_SUBJECT_DRUMS = "MUSICAL_INSTRUMENTS_SUBJECT_DRUMS",
  MUSICAL_INSTRUMENTS_SUBJECT_FLUTE = "MUSICAL_INSTRUMENTS_SUBJECT_FLUTE",
  MUSICAL_INSTRUMENTS_SUBJECT_GUITAR = "MUSICAL_INSTRUMENTS_SUBJECT_GUITAR",
  MUSICAL_INSTRUMENTS_SUBJECT_KEYBOARD = "MUSICAL_INSTRUMENTS_SUBJECT_KEYBOARD",
  MUSICAL_INSTRUMENTS_SUBJECT_PIANO = "MUSICAL_INSTRUMENTS_SUBJECT_PIANO",
  MUSICAL_INSTRUMENTS_SUBJECT_SAXOPHONE = "MUSICAL_INSTRUMENTS_SUBJECT_SAXOPHONE",
  MUSICAL_INSTRUMENTS_SUBJECT_TRUMPET = "MUSICAL_INSTRUMENTS_SUBJECT_TRUMPET",
  MUSICAL_INSTRUMENTS_SUBJECT_VIOLIN = "MUSICAL_INSTRUMENTS_SUBJECT_VIOLIN",
  MUSIC_DRAMA_SUBJECT_DRAMA_THEATER = "MUSIC_DRAMA_SUBJECT_DRAMA_THEATER",
  MUSIC_DRAMA_SUBJECT_GENERAL_MUSIC = "MUSIC_DRAMA_SUBJECT_GENERAL_MUSIC",
  MUSIC_DRAMA_SUBJECT_SINGING = "MUSIC_DRAMA_SUBJECT_SINGING",
  SCIENCE_SUBJECT_BIOLOGY = "SCIENCE_SUBJECT_BIOLOGY",
  SCIENCE_SUBJECT_CHEMISTRY = "SCIENCE_SUBJECT_CHEMISTRY",
  SCIENCE_SUBJECT_EARTH_SCIENCE = "SCIENCE_SUBJECT_EARTH_SCIENCE",
  SCIENCE_SUBJECT_ELEMENTARY_SCIENCE = "SCIENCE_SUBJECT_ELEMENTARY_SCIENCE",
  SCIENCE_SUBJECT_LIFE_SCIENCE = "SCIENCE_SUBJECT_LIFE_SCIENCE",
  SCIENCE_SUBJECT_MIDDLE_SCHOOL = "SCIENCE_SUBJECT_MIDDLE_SCHOOL",
  SCIENCE_SUBJECT_PHYSICS = "SCIENCE_SUBJECT_PHYSICS",
  SCIENCE_SUBJECT_PSYCHOLOGY = "SCIENCE_SUBJECT_PSYCHOLOGY",
  SPECIAL_EDUCATION_SUBJECT_ADD_ADHD = "SPECIAL_EDUCATION_SUBJECT_ADD_ADHD",
  SPECIAL_EDUCATION_SUBJECT_DYSLEXIA = "SPECIAL_EDUCATION_SUBJECT_DYSLEXIA",
  SPECIAL_EDUCATION_SUBJECT_EMOTIONAL_BEHAVIOR = "SPECIAL_EDUCATION_SUBJECT_EMOTIONAL_BEHAVIOR",
  SPECIAL_EDUCATION_SUBJECT_HEARING_IMPAIRED = "SPECIAL_EDUCATION_SUBJECT_HEARING_IMPAIRED",
  SPECIAL_EDUCATION_SUBJECT_LEARNING_DISABLED = "SPECIAL_EDUCATION_SUBJECT_LEARNING_DISABLED",
  SPECIAL_EDUCATION_SUBJECT_MILDLY_HANDICAPPED = "SPECIAL_EDUCATION_SUBJECT_MILDLY_HANDICAPPED",
  SPORTS_FITNESS_SUBJECT_BASEBALL = "SPORTS_FITNESS_SUBJECT_BASEBALL",
  SPORTS_FITNESS_SUBJECT_BASKETBALL = "SPORTS_FITNESS_SUBJECT_BASKETBALL",
  SPORTS_FITNESS_SUBJECT_FIELD_HOCKEY = "SPORTS_FITNESS_SUBJECT_FIELD_HOCKEY",
  SPORTS_FITNESS_SUBJECT_FOOTBALL = "SPORTS_FITNESS_SUBJECT_FOOTBALL",
  SPORTS_FITNESS_SUBJECT_GYMNASTICS = "SPORTS_FITNESS_SUBJECT_GYMNASTICS",
  SPORTS_FITNESS_SUBJECT_PERSONAL_TRAINING = "SPORTS_FITNESS_SUBJECT_PERSONAL_TRAINING",
  SPORTS_FITNESS_SUBJECT_RUNNING = "SPORTS_FITNESS_SUBJECT_RUNNING",
  SPORTS_FITNESS_SUBJECT_SOCCER = "SPORTS_FITNESS_SUBJECT_SOCCER",
  SPORTS_FITNESS_SUBJECT_SOFTBALL = "SPORTS_FITNESS_SUBJECT_SOFTBALL",
  SPORTS_FITNESS_SUBJECT_SWIMMING = "SPORTS_FITNESS_SUBJECT_SWIMMING",
  SPORTS_FITNESS_SUBJECT_TENNIS = "SPORTS_FITNESS_SUBJECT_TENNIS",
  SPORTS_FITNESS_SUBJECT_TRACK_AND_FIELD = "SPORTS_FITNESS_SUBJECT_TRACK_AND_FIELD",
  SPORTS_FITNESS_SUBJECT_UNNING = "SPORTS_FITNESS_SUBJECT_UNNING",
  SPORTS_FITNESS_SUBJECT_VOLLEYBALL = "SPORTS_FITNESS_SUBJECT_VOLLEYBALL",
  TEST_PREP_SUBJECT_3RD_GRADE_SOL = "TEST_PREP_SUBJECT_3RD_GRADE_SOL",
  TEST_PREP_SUBJECT_5TH_GRADE_SOL = "TEST_PREP_SUBJECT_5TH_GRADE_SOL",
  TEST_PREP_SUBJECT_ACT = "TEST_PREP_SUBJECT_ACT",
  TEST_PREP_SUBJECT_ELEMENTARY_STANDARD_TESTING = "TEST_PREP_SUBJECT_ELEMENTARY_STANDARD_TESTING",
  TEST_PREP_SUBJECT_GED = "TEST_PREP_SUBJECT_GED",
  TEST_PREP_SUBJECT_GMAT = "TEST_PREP_SUBJECT_GMAT",
  TEST_PREP_SUBJECT_GRE = "TEST_PREP_SUBJECT_GRE",
  TEST_PREP_SUBJECT_MIDDLE_SCHOOL_SOL = "TEST_PREP_SUBJECT_MIDDLE_SCHOOL_SOL",
  TEST_PREP_SUBJECT_PRIVATE_SCHOOL_ENTRANCE = "TEST_PREP_SUBJECT_PRIVATE_SCHOOL_ENTRANCE",
  TEST_PREP_SUBJECT_PSAT_TEST = "TEST_PREP_SUBJECT_PSAT_TEST",
  TEST_PREP_SUBJECT_SAT_MATH = "TEST_PREP_SUBJECT_SAT_MATH",
  TEST_PREP_SUBJECT_SAT_VERBAL = "TEST_PREP_SUBJECT_SAT_VERBAL",
  TEST_PREP_SUBJECT_TOEFL = "TEST_PREP_SUBJECT_TOEFL",
}

/**
 * Subject Types for Tutoring
 */
export enum TutoringSubjectType {
  ART = "ART",
  ARTS_AND_MUSIC = "ARTS_AND_MUSIC",
  BUSINESS = "BUSINESS",
  COMPUTERS = "COMPUTERS",
  COOKING_SEWING = "COOKING_SEWING",
  DANCE = "DANCE",
  DRIVING = "DRIVING",
  ENGINEERING = "ENGINEERING",
  ENGLISH = "ENGLISH",
  FOREIGN_LANGUAGE = "FOREIGN_LANGUAGE",
  MATH = "MATH",
  MUSICAL_INSTRUMENTS = "MUSICAL_INSTRUMENTS",
  MUSIC_AND_DRAMA = "MUSIC_AND_DRAMA",
  OTHER = "OTHER",
  SCIENCE = "SCIENCE",
  SOCIAL_STUDIES = "SOCIAL_STUDIES",
  SPECIAL_EDUCATION = "SPECIAL_EDUCATION",
  SPORTS_AND_FITNESS = "SPORTS_AND_FITNESS",
  TEST_PREP = "TEST_PREP",
}

/**
 * U.S. State Codes
 */
export enum UsStateCode {
  AK = "AK",
  AL = "AL",
  AR = "AR",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FE = "FE",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  PR = "PR",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

/**
 * The answer to a yes or no question.
 */
export enum YesOrNoAnswer {
  NO = "NO",
  NOT_SURE = "NOT_SURE",
  YES = "YES",
}

/**
 * Address details for the bookings.
 */
export interface AddressInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  id?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  state: string;
  zip: string;
}

/**
 * Input fields for an auto-accept lead.
 */
export interface AutoAcceptChildCareLeadPublishInput {
  acceptableDistance?: DistanceInput | null;
  attendingDays?: DayCareAttendingDays | null;
  careExpectations?: string | null;
  childrenDatesOfBirth: globalScalarLocalDate[];
  contactMethod?: ChildCareLeadContactMethod | null;
  googleTagManagerInput?: GoogleTagManagerInput | null;
  justBrowsing: boolean;
  providerIds: string[];
  seekerInfo: SeekerInfo;
  source: string;
  startDate?: globalScalarLocalDate | null;
  timeOfDay?: DayCareTimeOfDay | null;
  trackingId: string;
  zipcode: string;
}

/**
 * # Attributes of caregiver
 */
export interface CaregiverAttributesInput {
  comfortableWithPets?: boolean | null;
  covidVaccinated?: boolean | null;
  education?: EducationLevel | null;
  languages?: Language[] | null;
  ownTransportation?: boolean | null;
  smokes?: boolean | null;
  yearsOfExperience?: number | null;
}

/**
 * # Input type for updating caregiver attributes
 */
export interface CaregiverAttributesUpdateInput {
  caregiver?: CaregiverAttributesInput | null;
  childcare?: ChildcareCaregiverAttributesInput | null;
  serviceType: ServiceType;
}

/**
 * Input values for updating a caregiver's biography.
 */
export interface CaregiverBiographyUpdateInput {
  bio: string;
  firstName?: string | null;
  headline?: string | null;
  lastName?: string | null;
}

/**
 * Count of children for age groups
 */
export interface ChildCareAgeGroupsCount {
  count: number;
  group: ChildCareAgeGroups;
}

/**
 * Input fields for a Child Care Lead creation.
 */
export interface ChildCareLeadCreateInput {
  attendingDays?: DayCareAttendingDays | null;
  childCareExpectations?: string | null;
  childrenDatesOfBirth: globalScalarLocalDate[];
  contactMethod?: ChildCareLeadContactMethod | null;
  googleTagManagerInput?: GoogleTagManagerInput | null;
  leadId?: string | null;
  providerIds: string[];
  seekerInfo: SeekerInfo;
  source: string;
  startDate?: globalScalarLocalDate | null;
  submissionMethod: ChildCareLeadsSubmissionMethod;
  timeOfDay?: DayCareTimeOfDay | null;
  tourRequestStartTime?: globalScalarDateTime | null;
  trackingId: string;
  zipcode: string;
}

/**
 * A child care recipient (Input)
 */
export interface ChildCareRecipientInput {
  ageRange: ChildCareAgeRangeType;
  approximateDoB?: globalScalarLocalDate | null;
  gender?: Gender | null;
  id?: string | null;
}

/**
 * Child Care Search Criteria
 */
export interface ChildCareSearchCriteria {
  ageGroups?: ChildCareAgeGroupsCount[] | null;
  qualities?: ChildCareProviderQuality[] | null;
  services?: ChildCareService[] | null;
  yearsOfExperience?: number | null;
}

/**
 * Input for calculation of possible tax credit savings on child care
 */
export interface ChildCareTaxCreditSavingCalculationInput {
  numberOfChildren: number;
  weeklyHours: number;
  zipcode: string;
}

/**
 * Input fields from a child information.
 */
export interface ChildInformationInput {
  dateOfBirth: globalScalarLocalDate;
  id: string;
  name: string;
}

/**
 * # Childcare attributes of caregiver
 */
export interface ChildcareCaregiverAttributesInput {
  ageGroups?: ChildCareAgeGroups[] | null;
  careForSickChild?: boolean | null;
  carpooling?: boolean | null;
  certifiedNursingAssistant?: boolean | null;
  certifiedRegistedNurse?: boolean | null;
  certifiedTeacher?: boolean | null;
  childDevelopmentAssociate?: boolean | null;
  cprTrained?: boolean | null;
  craftAssistance?: boolean | null;
  doula?: boolean | null;
  earlyChildDevelopmentCoursework?: boolean | null;
  earlyChildhoodEducation?: boolean | null;
  errands?: boolean | null;
  expSpecialNeedsChildren?: boolean | null;
  experienceWithTwins?: boolean | null;
  firstAidTraining?: boolean | null;
  groceryShopping?: boolean | null;
  laundryAssistance?: boolean | null;
  lightHousekeeping?: boolean | null;
  mealPreparation?: boolean | null;
  nafccCertified?: boolean | null;
  numberOfChildren?: number | null;
  remoteLearningAssistance?: boolean | null;
  swimmingSupervision?: boolean | null;
  travel?: boolean | null;
  trustlineCertifiedCalifornia?: boolean | null;
}

/**
 * Hired Caregiver Event information
 */
export interface CzenCrmEventHiredCaregiver {
  isEnrollment: boolean;
  vertical: ServiceType;
}

/**
 * Input fields for creating a Caregiver Hired event.
 */
export interface CzenCrmEventHiredCaregiverInput {
  czenCrmEventHiredCaregiver: CzenCrmEventHiredCaregiver;
  userId: string;
}

/**
 * Leads Submitted Event Type
 */
export interface CzenCrmEventLeadsSubmitted {
  autoAccept: boolean;
  enrollment: boolean;
  existingLead?: boolean | null;
  leadCount: number;
  leads: CzenCrmLeadInput[];
  subVertical: SubServiceType;
  tourBookingTime?: globalScalarDateTime | null;
  vertical: ServiceType;
}

/**
 * Input fields for creating Leads Submitted crm events.
 */
export interface CzenCrmEventLeadsSubmittedInput {
  czenCrmEventLeadsSubmitted: CzenCrmEventLeadsSubmitted;
  userId: string;
}

/**
 * Lead Input
 */
export interface CzenCrmLeadInput {
  address: AddressInput;
  businessName: string;
  phoneNumber?: globalScalarPhoneNumber | null;
}

/**
 * A collection of non-overlapping time blocks for a single day
 */
export interface DailyScheduleInput {
  blocks: LocalTimeBlockInput[];
}

/**
 * Child Care Day Care - Attending Days
 */
export interface DayCareAttendingDays {
  friday?: boolean | null;
  monday?: boolean | null;
  saturday?: boolean | null;
  sunday?: boolean | null;
  thursday?: boolean | null;
  tuesday?: boolean | null;
  wednesday?: boolean | null;
}

/**
 * Input values for Distance
 */
export interface DistanceInput {
  unit: DistanceUnit;
  value: number;
}

/**
 * Input for enrolling in continuous monitoring
 */
export interface EnrollInContinuousMonitoringInput {
  consentGivenMessageIds: string[];
  memberId: string;
}

/**
 * Input for EligibilityVerification
 */
export interface EnterpriseEmployeeEnrollmentDetails {
  employeeInformation: EnterpriseEmployeeInformation;
  group: string;
}

/**
 * Input for the Employee releated Information for enterprise enrollment
 */
export interface EnterpriseEmployeeInformation {
  address: string;
  dateOfBirth?: globalScalarLocalDate | null;
  division?: string | null;
  email?: string | null;
  employeeId?: string | null;
  firstName: string;
  googleAuthIdToken?: string | null;
  lastName: string;
  lifeCareMemberId?: string | null;
  optForEmail?: boolean | null;
  password?: string | null;
  phoneNumber?: globalScalarPhoneNumber | null;
  primaryService?: ServiceType | null;
  role?: string | null;
  zip: string;
}

/**
 * The input for facebookConnect mutation.
 */
export interface FacebookConnectInput {
  accessToken: string;
}

/**
 * The input type to favorite providers.
 */
export interface FavoriteProviderInput {
  favoriteStatus?: boolean | null;
  memberId: string;
  serviceType: ServiceType;
}

/**
 * Input values for FavoriteRequest
 */
export interface FavoriteRequestInput {
  favoriteStatus: boolean;
  serviceProfileId: string;
}

/**
 * Input information used by Google Tag Manager
 */
export interface GoogleTagManagerInput {
  ga4ClientId?: string | null;
  ga4SessionId?: string | null;
}

/**
 * Input for HomePay Prospect
 */
export interface HomePayProspectInput {
  address: MailingAddressInput;
  caregiverType?: HomepayCaregiverType | null;
  email: string;
  expectedHireTimeFrame?: HomePayExpectedHireTimeFrame | null;
  firstName: string;
  hasHired?: boolean | null;
  lastName: string;
  partnerId?: string | null;
  phoneNumber: string;
  planId?: string | null;
  prospectLabel?: string | null;
  referringSite?: string | null;
}

/**
 * Input values for updating a housekeeping provider's attributes.
 */
export interface HouseKeepingProviderAttributesUpdateInput {
  houseKeepingTypeToProvide?: HousekeepingService[] | null;
  jobRate?: JobRateInput | null;
  yearsOfExperience?: number | null;
}

/**
 * Hourly limits for schedules
 */
export interface JobHoursInput {
  maximum?: number | null;
  minimum: number;
  unit: JobHoursUnit;
}

/**
 * The minimum and maximum hourly pay rate associated with a job
 */
export interface JobRateInput {
  maximum: MoneyInput;
  minimum: MoneyInput;
}

/**
 * Input for mutation leadConnectActionRecord
 */
export interface LeadConnectActionRecordInput {
  action: ActionType;
  actorType: ActorType;
  targetId: string;
  vertical: ServiceType;
}

/**
 * A block of time represented by a start and end time
 */
export interface LocalTimeBlockInput {
  end: globalScalarLocalTime;
  start: globalScalarLocalTime;
}

/**
 * Input values for logClickEvent mutation
 */
export interface LogClickEventInput {
  memberUuid: string;
}

/**
 * Input for mailing address
 */
export interface MailingAddressInput {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  state: UsStateCode;
  zip: string;
}

/**
 * Input fields for change member's password.
 */
export interface MemberChangePasswordInput {
  password: string;
}

/**
 * Money input to fetch monetary value
 */
export interface MoneyInput {
  amount: globalScalarDecimal;
  currencyCode: globalScalarCurrency;
}

/**
 * Input type for the create Multiple Verticals
 */
export interface MultipleVerticalsInput {
  serviceIds?: MultipleVerticalsTypes[] | null;
  test: string;
  testVariance: string;
}

/**
 * Structure to hold number of children and service rates based on that
 */
export interface OneTimeChildCareRatesInput {
  hourlyRate: MoneyInput;
  numberOfChildren: number;
}

/**
 * One time job interest details
 */
export interface OneTimeJobInterestInput {
  childCareJobRates: OneTimeChildCareRatesInput[];
  jobHours?: JobHoursInput | null;
}

/**
 * Input values for updating a pet care provider's attributes.
 */
export interface PetCareProviderAttributesUpdateInput {
  jobRate?: JobRateInput | null;
  petCareAnimalType?: (PetCareAnimalType | null)[] | null;
  petCareCertificationType?: (PetCareCertificationType | null)[] | null;
  petCareServiceType?: (ProviderPetCareServiceType | null)[] | null;
  yearsOfExperience?: number | null;
}

/**
 * Input values for updating a provider's availability.
 */
export interface ProviderAvailabilityUpdateInput {
  endDate?: globalScalarLocalDate | null;
  liveInLimits?: SchedulingLimits | null;
  oneTimeLimits?: SchedulingLimits | null;
  recurringLimits?: SchedulingLimits | null;
  schedule: WeeklyScheduleInput;
  serviceType?: ServiceType | null;
  startDate: globalScalarLocalDate;
}

/**
 * Input to create a provider account
 */
export interface ProviderCreateInput {
  distanceWillingToTravel?: DistanceInput | null;
  email: string;
  gender?: Gender | null;
  howDidYouHearAboutUs?: HOW_DID_YOU_HEAR_ABOUT_US | null;
  password: string;
  referrerCookie?: string | null;
  serviceType: ServiceType;
  zipcode: string;
}

/**
 * Input values to update provider job interests
 */
export interface ProviderJobInterestUpdateInput {
  oneTimeJobInterest?: OneTimeJobInterestInput | null;
  recurringJobInterest?: RecurringJobInterestInput | null;
  serviceType: ServiceType;
  source?: JobInterestUpdateSource | null;
}

/**
 * Input values to update provider name
 */
export interface ProviderNameUpdateInput {
  firstName: string;
  lastName: string;
}

/**
 * Recurring job interest details
 */
export interface RecurringJobInterestInput {
  jobHours?: JobHoursInput | null;
  jobRate: JobRateInput;
}

/**
 * Hourly limits for schedules
 */
export interface SchedulingLimits {
  maximumHours?: number | null;
  minimumHours?: number | null;
}

/**
 * Input values for seekerUpdate mutation
 */
export interface SeekerAttributesInput {
  additionalVerticals?: ServiceType[] | null;
  daycareInterest?: boolean | null;
  howDidYouHearAboutUs?: HOW_DID_YOU_HEAR_ABOUT_US | null;
}

/**
 * Input fields for creating a new care seeker
 */
export interface SeekerCreateInput {
  additionalVerticals?: ServiceType[] | null;
  addressLine1?: string | null;
  appleId?: string | null;
  careDate?: CareDate | null;
  careRecipients?: ChildCareRecipientInput[] | null;
  careType?: SENIOR_CARE_TYPE | null;
  email: string;
  enrollmentSource?: EnrollmentSource | null;
  firstName: string;
  gatedByPaywall?: boolean | null;
  googleId?: string | null;
  howDidYouHearAboutUs?: HOW_DID_YOU_HEAR_ABOUT_US | null;
  isExpecting?: boolean | null;
  lastName: string;
  newcareExperience?: NewcareExperience | null;
  password?: string | null;
  petCareSubtype?: PetCareSubtype | null;
  phone?: string | null;
  referrerCookie?: string | null;
  serviceType: ServiceType;
  subServiceType?: SubServiceType | null;
  zipcode: string;
}

/**
 * Input information about Seeker for Lead
 */
export interface SeekerInfo {
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  phoneNumber: string;
}

/**
 * Input values for seekerUpdate mutation
 */
export interface SeekerUpdateInput {
  attributes?: SeekerAttributesInput | null;
}

/**
 * Input values for sending a 1:many messages between at least two premium members
 */
export interface SendMessageInput {
  message: string;
  recipientMemberIds: string[];
  relatedJobId?: string | null;
  subject?: string | null;
}

/**
 * Input fields for senior assisted living community lead
 */
export interface SeniorAssistedLivingCommunityLeadPublishInput {
  careRecipientInfo?: SeniorFacilityCareRecipientInput | null;
  providerIds: string[];
  seekerInfo: SeekerInfo;
  source?: string | null;
  trackingId: string;
  zipcode: string;
}

/**
 * Input values to generate a senior care facility lead
 */
export interface SeniorCareFacilityLeadGenerateInput {
  acceptedCaringTermsOfUse: boolean;
  ageRange?: SeniorCareAgeRangeType | null;
  amenities?: SeniorCareFacilityAmenity[] | null;
  careRecipientCondition?: SeniorCareRecipientCondition | null;
  email: string;
  firstName: string;
  lastName: string;
  memoryCareFacilityNeeded?: YesOrNoAnswer | null;
  paymentSources?: SeniorCarePaymentSource[] | null;
  phone: string;
  relationship?: SeniorCareRecipientRelationshipType | null;
  serviceNeeded?: SeniorCareServiceNeededType[] | null;
  zipcode?: string | null;
}

/**
 * Input values for updating a senior care provider's attributes.
 */
export interface SeniorCareProviderAttributesUpdateInput {
  careTypeToProvide?: SeniorCareServiceProvidedType[] | null;
  education?: EducationLevel | null;
  jobRate?: JobRateInput | null;
  languages?: Language[] | null;
  qualities?: SeniorCareProviderQuality[] | null;
  vaccinated?: boolean | null;
  yearsOfExperience?: number | null;
}

/**
 * Input values for updating a senior care provider's availability.
 */
export interface SeniorCareProviderAvailabilityUpdateInput {
  endDate?: globalScalarLocalDate | null;
  liveInLimits?: SchedulingLimits | null;
  oneTimeLimits?: SchedulingLimits | null;
  recurringLimits?: SchedulingLimits | null;
  schedule: WeeklyScheduleInput;
  startDate: globalScalarLocalDate;
}

/**
 * Input to create a provider account
 */
export interface SeniorCareProviderCreateInput {
  email: string;
  howDidYouHearAboutUs?: HOW_DID_YOU_HEAR_ABOUT_US | null;
  milesWillingToTravel?: number | null;
  password: string;
  referrerCookie?: string | null;
  zipcode: string;
}

/**
 * The input for updating senior care seeker attributes.
 */
export interface SeniorCareSeekerAttributesUpdateInput {
  ageRange?: SeniorCareAgeRangeType | null;
  careRecipientCondition?: SeniorCareRecipientCondition | null;
  howSoonIsCareNeeded?: HowSoonIsCareNeeded | null;
  memoryCareFacilityNeeded?: YesOrNoAnswer | null;
  paymentSources?: SeniorCarePaymentSource[] | null;
}

/**
 * Input fields for creating a new senior care seeker.
 */
export interface SeniorCareSeekerCreateInput {
  additionalVerticals?: ServiceType[] | null;
  appleId?: string | null;
  careType?: SENIOR_CARE_TYPE | null;
  email: string;
  firstName: string;
  googleId?: string | null;
  howDidYouHearAboutUs?: HOW_DID_YOU_HEAR_ABOUT_US | null;
  lastName: string;
  newcareExperience?: NewcareExperience | null;
  password?: string | null;
  referrerCookie?: string | null;
  zipcode: string;
}

/**
 * Senior care input for the person receiving care with pertinent
 * information for in-facility care
 */
export interface SeniorFacilityCareRecipientInput {
  ageRange?: SeniorCareAgeRangeType | null;
  facilityType: SeniorCommunityType;
  relationship: SeniorCareRecipientRelationshipType;
}

/**
 * Signed url create input
 */
export interface SignedUrlCreateInput {
  fileName: string;
}

/**
 * Input for mutations that use a signed url as input
 */
export interface SignedUrlInput {
  etag: string;
  signature: string;
  url: globalScalarURL;
}

/**
 * Input type for test cell reference ids.
 */
export interface TestCellReferenceIdsInput {
  testCellReferenceIds: string[];
}

/**
 * Input type of the text creator and their session associated with a requested text analysis
 */
export interface TextAnalyzerDetectConcernsCreator {
  email?: string | null;
  givenName?: string | null;
  memberId: string;
  sessionId: string;
}

/**
 * Input values for updating a tutoring provider's attributes.
 */
export interface TutoringProviderAttributesUpdateInput {
  jobRate?: JobRateInput | null;
  tutoringCertification?: (TutoringCertification | null)[] | null;
  tutoringEducationLevel?: (TutoringEducationLevel | null)[] | null;
  tutoringExperience?: (TutoringExperience | null)[] | null;
  tutoringSpecificSubjectType?: (TutoringSpecificSubjectType | null)[] | null;
  tutoringSubjectType?: (TutoringSubjectType | null)[] | null;
  yearsOfExperience?: number | null;
}

/**
 * A map of daily schedules for every day of the week
 */
export interface WeeklyScheduleInput {
  monday?: DailyScheduleInput | null;
  tuesday?: DailyScheduleInput | null;
  wednesday?: DailyScheduleInput | null;
  thursday?: DailyScheduleInput | null;
  friday?: DailyScheduleInput | null;
  saturday?: DailyScheduleInput | null;
  sunday?: DailyScheduleInput | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
